export default __webpack_public_path__ + "static/AGaramondPro-Semibold-b101bde80aece8087366e6e743e06562.otf";